import { render, staticRenderFns } from "./create-product-pricing.vue?vue&type=template&id=47f44d61&"
import script from "./create-product-pricing.vue?vue&type=script&lang=ts&"
export * from "./create-product-pricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports